import { BaseModel } from './base.model';
import { DynamicListItemModel } from './dynamic-list-item.model';
import { DynamicListFieldRawModel } from './dynamic-list-field-raw.model';

export class DynamicListFieldRawResponseModel extends BaseModel {
    value: string;

    dyn_list_item_id: number;
    dyn_list_field_raw_id: number;

    // Associations
    dyn_list_item: DynamicListItemModel;
    dyn_list_field_raw: DynamicListFieldRawModel;

    // Auxiliars - Modified data
    dyn_list_id: number; // ref => dyn_list_item

    static validate(list: DynamicListFieldRawResponseModel): boolean {
        return !!(list.value);
    }

    constructor(list?: DynamicListFieldRawResponseModel) {
        super();

        this.value = list ? list.value || null : null;

        this.dyn_list_item_id = list ? list.dyn_list_item_id || null : null;
        this.dyn_list_field_raw_id = list ? list.dyn_list_field_raw_id || null : null;

        this.dyn_list_item = list ? list.dyn_list_item || null : null;
        this.dyn_list_field_raw = list ? list.dyn_list_field_raw || null : null;

        this.dyn_list_id = list ? list.dyn_list_id || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/dynamic-list-field-raw-response.model.ts